import axios from "./index";
import { buildLoginError } from "./login_error";

export default {
  login(callback, params) {
    axios.post("/api/v1/doctors/session", {
      doctor: {
        email: params.email,
        password: params.password,
        remember_me: 0
      }
    }
    ).then(() => {
      callback({ loggedIn: true, error: null });
    }).catch(error => {
      console.log(error);
      callback({ loggedIn: false, error: buildLoginError(error) });
    });
  },

  logout(callback) {
    axios.delete("/api/v1/doctors/session").then(() => {
      callback(false);
    }).catch(error => {
      console.log(error);
    });
  },

  checkLoggedIn(callback) {
    axios.get("/api/v1/doctors/logged_in").then(response => {
      callback(response.data);
    }).catch(error => {
      console.log(error);
    });
  },
  
  fetchCurrentDoctor(callback) {
    axios.get("/api/v1/doctors/current_session").then(response => {
      callback(response.data);
    }).catch(error => {
      console.log(error);
    });
  },

  fetchAuthSetting(callback) {
    axios.get("/api/v1/karte_system_setting").then(response => {
      callback(response.data);
    }).catch(error => {
      console.log(error);
    });
  }
};
